<template>
  <cell-list-live-player
    key="infiniteCellList"
    v-infinite-scroll="loadMore"
    :cell-list="cellList"
    :thumbnail-info="thumbnailInfo"
    :container-class-name="containerClassName"
    infinite-scroll-distance="100"
    infinite-scroll-throttle-delay="200"
  ></cell-list-live-player>
</template>

<script>
  import CellListLivePlayer from '@/components/section/template/cell/CellListLivePlayer'
  import { infiniteScroll } from '@/common/directives'

  export default {
    name: 'InfiniteScrollCellList',
    components: { CellListLivePlayer },
    directives: {
      infiniteScroll,
    },
    props: ['cellList', 'thumbnailInfo', 'containerClassName'],
    methods: {
      loadMore() {
        this.$emit('load-more')
      },
    },
  }
</script>
